import React from "react";
import { object, string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { HeroSection } from "../HeroSection";
import { cloudinaryImageAdapter } from "../../sharedComponents/CloudinaryImageAdapter";
import { useInteraction } from "../../sharedComponents/Hooks/Interaction";

const HeaderTilesConnector = ({ data, locale }) => {
	const primaryTileImage = useInteraction(
		cloudinaryImageAdapter({
			cloudinaryImage: data.primaryTile?.cloudinaryImage?.[0],
			adoptHeight: true,
			aspectRatio: 1.77,
			preLoad: true,
			maxWidth: 800,
			imageQuality: [0.25, 0.5, 1, 2],
			sizes: "(max-width:400px) 80vw, 600px",
		}),
		cloudinaryImageAdapter({
			cloudinaryImage: data.primaryTile?.cloudinaryImage?.[0],
			adoptHeight: true,
			aspectRatio: 1.77,
			preLoad: true,
			sizes: "(max-width:400px) 80vw, 600px",
			imageQuality: [0.5, 1, 2],
			maxWidth: 800,
		})
	);

	switch (data.primaryTile?.sys?.contentType?.sys?.id) {
		case "linkTile":
			return (
				<HeroSection
					primaryTile={{
						id: data.primaryTile.id,
						image: {
							...primaryTileImage,
							fluid: {
								...primaryTileImage.fluid,
								aspectRatio: 3.03,
								height: parseInt(primaryTileImage.fluid.width / 3.03, 10),
							},
						},
						color: data.primaryTile.color,
						header: data.primaryTile.displayTitle,
						subheader: data.primaryTile.subTitle,
						button: {
							to: data.primaryTile?.button?.link || data.primaryTile?.link?.url,
							text: data.primaryTile?.button?.text || data.primaryTile?.link?.linkText,
							target: data.primaryTile?.button?.target || data.primaryTile?.link?.target,
							variant: data.primaryTile?.button?.variant,
						},
						logo: {
							...cloudinaryImageAdapter({
								cloudinaryImage: data?.primaryTile?.logo?.[0],
								title: data?.primaryTile?.title,
								aspectRatio: 2.17,
							}),
						},
						logoPosition: data?.primaryTile?.logoPosition,
						variant: data?.primaryTile?.variant,
					}}
					otherTiles={[
						...data.otherTiles.map(tile => {
							let image = {
								...cloudinaryImageAdapter({
									cloudinaryImage: tile.cloudinaryImage[0],
									adoptHeight: true,
									maxWidth: 400,
									preLoad: true,
									aspectRatio: 1.77,
								}),
							};
							image = {
								...image,
								fluid: {
									...image.fluid,
									aspectRatio: 3.3,
									height: parseInt(image.fluid.width / 3.33, 10),
								},
							};
							return {
								id: tile.id,
								image,
								color: tile.color,
								link: {
									to: tile?.link?.url,
									text: tile.displayTitle,
									target: tile?.link?.target,
								},
								linkIcon: tile.iconName,
							};
						}),
					]}
					locale={locale}
				/>
			);
		case "gallery":
			return (
				<HeroSection
					gallery={{
						images: data.primaryTile.images.map(i => ({
							id: i.id,
							alt: i.title,
							imageTitle: i.title,
							...cloudinaryImageAdapter({
								cloudinaryImage: i.cloudinaryAsset?.[0],
								title: i.title,
								adoptHeight: true,
								aspectRatio: 1.9,
								maxWidth: 1200,
							}),
						})),
						map: data.primaryTile.map && {
							alt: data.primaryTile.title,
							imageTitle: data.primaryTile.title,
							...cloudinaryImageAdapter({
								cloudinaryImage: data.primaryTile.cloudinaryAsset?.[0],
								title: data.primaryTile.title,
								adoptHeight: true,
							}),
						},
						detailMap: data.primaryTile.detailMap,
						video: data.primaryTile.video,
						logo: {
							...cloudinaryImageAdapter({
								cloudinaryImage: data?.primaryTile?.logo?.[0],
								title: data?.primaryTile?.title,
								aspectRatio: 2.17,
							}),
						},
						logoPosition: data?.primaryTile?.logoPosition,
					}}
					otherTiles={[
						...data.otherTiles.map(tile => ({
							id: tile.id,
							image: {
								...cloudinaryImageAdapter({
									cloudinaryImage: tile.cloudinaryImage[0],
									adoptHeight: true,
								}),
							},
							link: {
								to: tile?.link?.url,
								text: tile.displayTitle,
								target: tile?.link?.target,
							},
							color: tile.color,
							linkIcon: tile.iconName,
						})),
					]}
					locale={locale}
				/>
			);
		default:
			return <></>;
	}
};
HeaderTilesConnector.propTypes = {
	data: object.isRequired,
	locale: string,
};

HeaderTilesConnector.defaultProps = {
	locale: null,
};

export default HeaderTilesConnector;
export { HeaderTilesConnector };
